module.exports = __webpack_public_path__ + "img/354.193e1190.png";